import { ArrowRightIcon, HelpIcon, WarningIcon } from '../../../../../assets/icons/common';
import { PreRecruitingInterviewIllustration } from '../../../../../assets/illustrations';
import { getRecruitingInterviewDataThunk } from '../../../../../store/exam/thunks';
import { RecruitingInterviewData } from '../../../../../store/exam/types';
import { setNotification } from '../../../../../store/general/slice';
import { setExamRulesModal } from '../../../../../store/exam/slice';
import Spinner from '../../../../../components/Spinner';
import { useDispatch } from '../../../../../store/store';
import Button from '../../../../../components/Button';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';

interface Props {
    jobId: any;
    action: string;
    isFetchingData: boolean;
    startInterview: () => void;
};

export default function PreInterview(props: Props) {
    const {
        action,
        jobId,
        isFetchingData,
        startInterview,
    } = props;

    const dispatch = useDispatch();
    const [interviewData, setInterviewData] = useState<RecruitingInterviewData | null>(null);
    const [hasMediaPermissions, setHasMediaPermissions] = useState(false);
    const [permissionDenied, setPermissionDenied] = useState(false);

    const requestMediaPermissions = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
            stream.getTracks().forEach(track => track.stop());
            setHasMediaPermissions(true);
            setPermissionDenied(false);
        } catch (error) {
            setHasMediaPermissions(false);
            setPermissionDenied(true);
            dispatch(setNotification(['Please enable camera and microphone access to continue.', 'error']));
        }
    };

    // Check permissions periodically
    // useEffect(() => {
    //     const checkPermissions = async () => {
    //         try {

    //             const permissions = await navigator.mediaDevices.enumerateDevices();
    //             const videoDevice = permissions.find(device => device.kind === 'videoinput');
    //             const audioDevice = permissions.find(device => device.kind === 'audioinput');
    //             console.log('checking camera', videoDevice,
    //                 audioDevice);

    //             if (!videoDevice?.label || !audioDevice?.label) {
    //                 setHasMediaPermissions(false);
    //                 setPermissionDenied(true);
    //             }
    //         } catch (error) {
    //             setHasMediaPermissions(false);
    //             setPermissionDenied(true);
    //         }
    //     };

    //     const permissionInterval = setInterval(checkPermissions, 1000);
    //     return () => clearInterval(permissionInterval);
    // }, []);

    useEffect(() => {
        requestMediaPermissions();

        dispatch(getRecruitingInterviewDataThunk({
            jobId,
            pre: 0,
        }))
            .unwrap()
            .then(res => {
                setInterviewData(res)
            })
            .catch(() => {
                dispatch(setNotification(['An error occured, please try again.', 'error']));
            })
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.detail}>
                <PreRecruitingInterviewIllustration />
                <span className={styles.detail_title}>Press the start button when you're ready</span>
                {!interviewData ? <Spinner /> : <ul>
                    <li>Your video will be recorded during the interview.</li>
                    <li>
                        There are <b>{interviewData?.countQuestions}</b> questions
                        to answer, with total <b>{interviewData.time}</b> minutes.
                    </li>
                </ul>}
                {permissionDenied && (
                    <div className={styles.warning}>
                        <div className={styles.warning_description}>
                            <WarningIcon />
                            <span>Before the exam begins, you must give permission to camera and microphone record the session.</span>
                        </div>
                        <span className={styles.warning_link} onClick={requestMediaPermissions}>Enable camera record</span>
                    </div>)}
                <Button
                    type='Primary'
                    className={styles.CTA}
                    onClick={startInterview}
                    loading={isFetchingData}
                    disabled={!interviewData || !hasMediaPermissions}
                    text={`${action === 'resume' ? 'Continue' : 'Start'} recruiting interview`}
                />
                <div className={styles.extra}>
                    <span className={styles.extra_text}>
                        Please review interview rules before starting
                    </span>
                    <div
                        className={styles.extra_btn}
                        onClick={() => dispatch(setExamRulesModal(true))}
                    >
                        <span>Exams rules</span>
                        <ArrowRightIcon />
                    </div>
                </div>
            </div>
        </div>
    )
}
